import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";

import Footer from "./Footer";
import Header from "./Header";
import Loader from "./Loader";

import "./index.css";
import Order from "./Order/Order";
import Partner from "./Partner/index";
import partners from "./utils/partners.json";

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            paymentStatus: this.props.match.params.status,
            error: null,
            isOrderLoading: false,
            isPartnerLoading: false,
            order: null,
            partner: null,
            username: this.extractUsernameFromURL(),
        };
    }

    extractUsernameFromURL() {
        const url = window.location.pathname;
        console.log(url);
        const username = decodeURIComponent(url.split("/")[1]);
        return username;
    }

    getPartnerName() {
        const username = this.state.username.toLocaleLowerCase();
        if (Object.hasOwn(partners, username)) {
            return partners[username];
        }
    }

    // componentWillMount() {
    //     if (this.state.paymentStatus) {
    //         this.props.history.replace({
    //             pathname: `/${this.props.match.params.paymentId}`,
    //         });
    //     }
    // }

    componentDidMount() {
        const headers = new Headers({
            "Content-Type": "application/json",
            Authorization: "Bearer PTY9lBkptEX5t7tevxo0smKkRduYiYTZ",
        });

        if (this.state.username) {
            const partner = this.getPartnerName();
            if (partner) {
                this.setState({
                    isPartnerLoading: true,
                });
                fetch(`/api/payments/partners/${partner}`, {
                    headers,
                })
                    .then((response) => {
                        if (response.status === 200) {
                            return response.json();
                        }
                        if (response.status === 404) {
                            throw new Error(
                                "Такого пользователя не существует"
                            );
                        }
                        throw new Error(
                            `Ошибка получения данных, попробуйте позже! ${response.statusText}`
                        );
                    })
                    .then((partner) => {
                        this.setState({ partner, isPartnerLoading: false });
                    });
            }
        }

        const { paymentId } = this.props.match.params;

        if (!paymentId) {
            return;
        }
        this.setState({
            isOrderLoading: true,
        });
        fetch(`/api/payments/${paymentId}`, {
            headers: headers,
        })
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                }
                if (response.status === 400) {
                    throw new Error(
                        "Проверьте правильность ссылки для оплаты!"
                    );
                }
                if (response.status === 404) {
                    throw new Error(
                        "Заказ не найден :( Проверьте правильность ссылки для оплаты!"
                    );
                }
                throw new Error(
                    `Ошибка получения данных, попробуйте позже! ${response.statusText}`
                );
            })
            .then((order) => {
                this.setState({ isOrderLoading: false, order });
            })
            .catch((error) => {
                this.setState({ isOrderLoading: false, error: error.message });
            });
    }

    render() {
        const { error, isOrderLoading, isPartnerLoading, order, partner } =
            this.state;
        const username = partner ? partner.domain_name : null;

        if (isOrderLoading || isPartnerLoading) {
            return <Loader variant="info" message="Загрузка..." />;
        }
        if (error) {
            return <Loader variant="error" message={error} />;
        }

        if (order && partner) {
            if (order.partnerDomainName !== partner.domain_name) {
                return <RedirectSteklo orderId={order.paymentId} />;
            }
        }

        return (
            <React.Fragment>
                <Header partner={partner} />
                {order && (
                    <Order
                        regNum={order.regNum}
                        lines={order.lines}
                        status={order.status}
                        managerName={order.managerName}
                        managerContact={order.managerContact}
                        estimation={order.estimation}
                        total={order.total}
                        username={username}
                        paymentId={order.paymentId}
                        goal={order.goal}
                        deliveryType={order.deliveryType}
                        pickupPoint={order.pickupPoint || ""}
                        partner={partner}
                    />
                )}
                {partner && !order && <Partner />}
                <Footer order={order} username={username} partner={partner} />
            </React.Fragment>
        );
    }
}

class RedirectSteklo extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (!this.props.orderId) {
            window.location.assign("https://стекло24.москва");
        }
    }

    render() {
        const orderId = this.props.orderId;
        if (!orderId) {
            return null;
        }
        return <Redirect to={`/${orderId}`} />;
    }
}

const Main = () => (
    <React.Fragment>
        <CssBaseline />
        <BrowserRouter>
            <Switch>
                {Object.keys(partners).map((partnerRu) => (
                    <Route
                        key={partnerRu}
                        path={`/${partnerRu.toLocaleLowerCase()}/:paymentId?/:status?`}
                        component={App}
                        exact
                    />
                ))}
                <Route path="/:paymentId/:status?" component={App} />
                <Route component={RedirectSteklo} />
            </Switch>
        </BrowserRouter>
    </React.Fragment>
);

ReactDOM.render(<Main />, document.querySelector("#app"));



// WEBPACK FOOTER //
// ./src/index.js